import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { LoaderSizes } from "atoms/constants/loader-sizes";
import { LoaderStyles } from "atoms/constants/loader-styles";
import Loader from "atoms/loaders/loader";
import React from "react";

export interface SuggestionAction {
    label: string;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    isLoading?: boolean;
    disabled?: boolean;
}

export interface SuggestionProps {
    children: (supportingText: string) => React.ReactNode;
    supportingText: string;
    primaryAction: SuggestionAction;
    secondaryAction: SuggestionAction;
    cssClassName?: string;
}

const BASE_CLASS = "c-suggestion";

const Suggestion: React.FC<SuggestionProps> = ({
    children,
    supportingText,
    primaryAction,
    secondaryAction,
    cssClassName,
}) => {
    return (
        <section className={`${BASE_CLASS} ${cssClassName ?? ""}`}>
            {children(supportingText)}
            <div className={`${BASE_CLASS}__actions`}>
                <Button
                    onClick={primaryAction.onClick}
                    disabled={primaryAction.disabled || primaryAction.isLoading}
                    cssClassName={primaryAction.isLoading ? "-loading" : ""}
                    size={ButtonSizes.Small}
                    style={ButtonStyles.Primary}>
                    {primaryAction.isLoading ? (
                        <Loader
                            size={LoaderSizes.XSmall}
                            type={LoaderStyles.LinkGlyphGray}
                        />
                    ) : (
                        primaryAction.label
                    )}
                </Button>
                <Button
                    onClick={secondaryAction.onClick}
                    disabled={
                        secondaryAction.disabled || secondaryAction.isLoading
                    }
                    cssClassName={secondaryAction.isLoading ? "-loading" : ""}
                    size={ButtonSizes.Small}
                    style={ButtonStyles.Secondary}>
                    {secondaryAction.isLoading ? (
                        <Loader
                            size={LoaderSizes.XSmall}
                            type={LoaderStyles.LinkGlyphGray}
                        />
                    ) : (
                        secondaryAction.label
                    )}
                </Button>
            </div>
        </section>
    );
};

export default Suggestion;
